export enum ClientStatus {
  Actif = 1,
  Suspendu = 2,
  Inactif = 3,
  EnPeriodeTrial = 4,
}

export enum OrderStatus {
  Pending = 1,
  Completed = 2,
  Cancelled = 3,
  Suspended = 4,
  Failed = 5,
}

export enum SubscriptionStatus {
  Active = 1,
  Suspended = 2,
  Expired = 3,
  PendingCancel = 4,
  Deleted = 5,
}

export enum OfferStatus {
  Brouillon = 1,
  EnValidation = 2,
  Envoyee = 3,
  Acceptee = 4,
  Refusee = 5,
  Expiree = 6,
}

export enum BillingCycle {
  Monthly = 1,
  Annual = 2,
  Triennial = 3,
  OneTime = 4,
}

export enum UserRole {
  Admin = 1,
  Commercial = 2,
  Manager = 3,
}

export enum AuditActionType {
  Create = 1,
  Update = 2,
  Delete = 3,
  View = 4,
  Sync = 5,
  Export = 6,
  EmailSent = 7,
}

export enum CacheDataType {
  Product = 1,
  SKU = 2,
  Pricing = 3,
  Availability = 4,
}

export enum ClientTag {
  CSP = 1,
  Enterprise = 2,
  SMB = 3,
  Education = 4,
  Government = 5,
  Partner = 6,
  VIP = 7,
}
